import { IS_ORDER } from '../../action-types/ui/isOrder';

export const STATE_KEY = 'isOrder';

export const isOrder = (state = false, action) => {
  switch (action.type) {
    case IS_ORDER: {
      const { flag } = action;
      return flag;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/isOrder.js